export default __webpack_public_path__ + "static/media/bg-portfolio.9fae24c3.jpg";